import Grid from '../components/mdx/grid'
import SpeakerDeck from '../components/mdx/speakerdeck'
import YouTube from '../components/mdx/youtube'

export default {
  Grid,
  YouTube,
  SpeakerDeck,
}
